class Filter {
    constructor (element, path, params) {
        this.params = params
        this.$element = $(element)
        this.filterId = this.$element.data('filterId')
        this.path = path
        this.values = (params.get(this.filterId) || "").split(",").filter(v => v.length > 0)

        this.$element.find('a').click((evt) => {
            evt.preventDefault()
            this.handleFilter(evt)
        })

        if (this.values.length > 0)
            this.$element.find('.dropdown-toggle').addClass('active')

        this.$element.find('a.dropdown-item').each((_, link) => {
            if (this.values.indexOf(link.dataset.item) >= 0) $(link).addClass('selected')
        })
    }

    handleFilter (evt) {
        const item = evt.target.dataset.item

        if (item) {
            const index = this.values.indexOf(item)

            if (index >= 0) this.values.splice(index, 1)
            else            this.values.push(item)

            this.params.set(this.filterId, this.values.join(","))
        } else {
            this.params.delete(this.filterId)
        }

        const newLocation = `${this.path}?${this.params.toString()}`

        if(Turbolinks.supported) Turbolinks.visit(newLocation)
        else window.location.replace(newLocation)
    }

}

function createFilter () {
    const filters = $("#movies-filter .all")
    const params = new URLSearchParams(window.location.search)

    filters.each((_, filter) => new Filter(filter, window.location.pathname, params))
}

$(createFilter)